import React from "react";
import LandingHeader from "../components/landing/header";
import LandingFooter from "../components/landing/footer";
import { clx } from "../utils/clx";

export default function StaticLayout({ classname, children }) {
  return (
    <div className={clx("flex min-h-screen flex-col bg-white font-gantari", classname)}>
      <LandingHeader />
      <main className="w-full flex-1">{children}</main>
      <LandingFooter />
    </div>
  );
}
